import { render, staticRenderFns } from "./SubcategoriasListAdmin.vue?vue&type=template&id=420d0845&scoped=true&"
import script from "./SubcategoriasListAdmin.vue?vue&type=script&lang=js&"
export * from "./SubcategoriasListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SubcategoriasListAdmin.vue?vue&type=style&index=0&id=420d0845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420d0845",
  null
  
)

export default component.exports